import { render, staticRenderFns } from "./orderLsList.vue?vue&type=template&id=4f5ca096&scoped=true"
import script from "./orderLsList.vue?vue&type=script&lang=js"
export * from "./orderLsList.vue?vue&type=script&lang=js"
import style0 from "./orderLsList.vue?vue&type=style&index=0&id=4f5ca096&prod&scoped=true&lang=css"
import style1 from "./orderLsList.vue?vue&type=style&index=1&id=4f5ca096&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5ca096",
  null
  
)

export default component.exports